import { ReferralregisterComponent } from './login-with-otp/referralregister/referralregister.component';
import { MyCustomersComponent } from './my-customers/my-customers.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginWithOtpComponent } from './login-with-otp/login-with-otp.component';
import { HomeComponent } from './home/home.component';
import { OtpConfirmationComponent } from './login-with-otp/otp-confirmation/otp-confirmation.component';
import { MyReferralComponent } from './my-referral/my-referral.component';
import { MyBusinessComponent } from './my-business/my-business.component';
import { ViewComponent } from './view/view.component';
import { AuthGuardGuard } from './authentication_guard/auth-guard.guard'
import { ForgetReferralComponent } from './login-with-otp/forget-referral/forget-referral.component';




const routes: Routes = [

  {
    path: '', component: LoginWithOtpComponent,
  },
  {
    path: 'otp', component: OtpConfirmationComponent,
  },
  {
    path: 'registration', component: ReferralregisterComponent, 
  },
  {
    path: 'forgot-referral', component: ForgetReferralComponent,
  },
  {
    path: 'view', component: ViewComponent, canActivate: [AuthGuardGuard],
    children: [
      {
        path: '', component: HomeComponent,
      },
      {
        path: 'myreferral', component: MyReferralComponent,
      },
      {
        path: 'mybusiness', component: MyBusinessComponent,
      },
      {
        path: 'mycustomers', component: MyCustomersComponent,
      },

    ],
  },
  {
    path: '**', redirectTo: '', pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
